const regex = /[^A-Z0-9+-]/ig;

//
// Ensure valid floor override characters
//
export const floorOverrideNormalizer = (value: string) =>
    (value || '').replace(regex, '').toUpperCase();

